import React from "react";
import { connect } from "react-redux";
import { Translation } from "react-i18next";
import toast from "react-hot-toast";
import { FaLock, FaEye, FaEyeSlash, FaUser, FaCoins, FaWallet, FaGift, FaIdBadge } from "react-icons/fa";
import { logout } from "_actions";
import { UpdateLang } from "_actions";
import { UserService } from "_services";
import { getCurrency } from "components/Navbar/NavUserBox";

const InfoRow = ({ label, value, icon }) => (
  <div className="flex items-center gap-3 rounded-xl border border-primary-400 bg-secondary-500/60 px-3 py-3">
    <div className="w-9 h-9 rounded-lg bg-secondary-50 flex items-center justify-center text-primary-500 shrink-0 text-sm">
      {icon}
    </div>
    <span className="text-secondary-50 text-sm flex-1">{label}</span>
    <span className="text-white text-sm font-semibold">{value ?? "-"}</span>
  </div>
);

const Profile = (props) => {
  const [password, setPassword] = React.useState("");
  const [showPassword, setShowPassword] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const userInfo = { ...props.user, ...props.user?.RelUser };
  const currency = getCurrency(userInfo.Currency);
  const balance = (props.wallet?.main ?? 0).toLocaleString("tr-TR", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });
  const bonus = (props.wallet?.bonus ?? 0).toLocaleString("tr-TR", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });

  const handleUpdatePassword = (t) => {
    if (!password) return;
    if (password.trim().length < 6) {
      toast.error(t("ERR_PASSWORD_MIN_6"));
      return;
    }
    setLoading(true);
    UserService.UPDATE_PASSWORD(password)
      .then(() => {
        toast.success(t("SUCCESS_UPDATE_PASSWORD"));
        setPassword("");
        setLoading(false);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.failText?.[0] || t("ERR_PASSWORD"));
        setLoading(false);
      });
  };

  return (
    <Translation>
      {(t) => (
        <div className="h-full p-2">
          <h1 className="text-lg px-4 py-3 bg-secondary-500/90 rounded-t-lg text-white font-semibold">
            {t("TITLE_MYACCOUNT")}
          </h1>
          <div
            style={{
              overflow: "auto",
              height: `calc(100dvh - 262px)`,
              WebkitOverflowScrolling: "touch",
            }}
            className="p-4 md:p-5 bg-secondary-500/95 rounded-b-lg flex flex-col gap-5 pb-8"
          >
            <div className="flex flex-col gap-3">
              <span className="text-white text-base font-bold">
                {t("PROFILE_CHANGE_PASSWORD")}
              </span>
              <div className="flex items-center gap-2.5 rounded-xl border border-primary-400 bg-secondary-400/50 px-3.5 py-3">
                <FaLock className="text-white shrink-0" />
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder={t("TXT_NEWPASSWORD")}
                  autoComplete="off"
                  className="flex-1 min-w-0 bg-transparent outline-none text-white placeholder-white/50 text-sm"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((v) => !v)}
                  aria-label={showPassword ? "Hide password" : "Show password"}
                  className="text-white hover:text-white shrink-0"
                >
                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                </button>
              </div>
              <button
                type="button"
                disabled={!password || loading}
                onClick={() => handleUpdatePassword(t)}
                className={`w-full rounded-xl py-3 font-bold text-sm uppercase tracking-wide transition-transform ${
                  !password || loading
                    ? "bg-gradient-to-r from-primary-500 via-primary-500 to-primary-500 opacity-40 text-white cursor-not-allowed"
                    : "bg-gradient-to-r from-primary-500 via-primary-500 to-primary-500 text-white shadow-lg shadow-secondary-400/40 active:scale-[0.98]"
                }`}
              >
                {loading ? (
                  <span className="loading loading-spinner loading-sm" />
                ) : (
                  t("BUTTON_UPDATE")
                )}
              </button>
            </div>

            <div className="w-full h-px bg-gradient-to-r from-transparent via-secondary-600 to-transparent" />

            <div className="flex flex-col gap-3">
              <span className="text-white text-base font-bold">
                {t("PROFILE_ACCOUNT_INFO")}
              </span>
              <div className="flex flex-col gap-2.5">
                <InfoRow label={t("TXT_USERNAME")} value={userInfo.UserName} icon={<FaUser />} />
                <InfoRow label={t("TXT_ID")} value={userInfo.UserID} icon={<FaIdBadge />} />
                <InfoRow label={t("TXT_NAME")} value={userInfo.FirstName} icon={<FaUser />} />
                <InfoRow label={t("TXT_CURRENCY")} value={userInfo.Currency} icon={<FaCoins />} />
                <InfoRow label={t("TXT_BALANCE")} value={`${balance} ${currency}`} icon={<FaWallet />} />
                <InfoRow label={t("TXT_BONUS")} value={`${bonus} ${currency}`} icon={<FaGift />} />
              </div>
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
};

const mapStateToProps = (state, props) => {
  const { authentication, game } = state;
  const { user, loggedIn, currentLang, wallet } = authentication;
  const { sports, games } = game;
  return {
    user,
    loggedIn,
    sports,
    games,
    currentLang,
    wallet,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(logout()),
    UpdateLang: (data) => dispatch(UpdateLang(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Profile);
